"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgFlightTransitionAdditionalMobile = function SvgFlightTransitionAdditionalMobile(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105 22",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1.405 1.465)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#B5A48B",
    d: "M9.595 18.535s5.702-3.3 18.096-3.3c12.395 0 18.097 3.3 18.097 3.3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.095,
    cy: 19.035,
    r: 1.5,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#877C68",
    d: "M19.616 10.182c2.282-.933 4.968-1.555 8.075-1.555 12.395 0 18.097 9.908 18.097 9.908"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B5A48B",
    d: "M50.595 18.535s5.856-3.3 18.585-3.3c12.73 0 18.586 3.3 18.586 3.3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.095,
    cy: 19.035,
    r: 1.5,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#877C68",
    d: "M50.595 18.535S56.45 8.627 69.18 8.627s18.586 9.908 18.586 9.908"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#251C0E",
    d: "m7.274 15.715-2.432 1.481s-.646.5-1.864.25c-1.217-.25-2.466-.523-2.466-.523s-.268-.097-.452.14c-.185.238.119.38.119.38l1.878 1.351s.4.394.99.29c.59-.103 2.325-.453 2.325-.453s1.184-.25 2.592-1.123c1.408-.873 6.44-3.907 6.44-3.907s1.96-1.106 1.763-1.57c-.196-.462-1.325-.339-1.865-.169s-4.755 2.542-4.755 2.542l-4.619-1.572s-.597-.142-.298.205c.298.346 3.225 3.24 3.225 3.24m1.32 1.611 1.255 1.244s.364.287.438-.712c.074-.998.148-1.746.148-1.746M93.499 4.005l-2.385 1.482s-.633.5-1.827.25-2.418-.524-2.418-.524-.263-.097-.444.141c-.18.238.117.38.117.38l1.842 1.35s.392.395.97.291c.579-.103 2.28-.453 2.28-.453s1.16-.251 2.54-1.124c1.381-.872 6.316-3.907 6.316-3.907s1.92-1.106 1.727-1.569c-.192-.463-1.3-.339-1.829-.17-.53.17-4.66 2.543-4.66 2.543l-4.53-1.573s-.585-.14-.292.206c.292.346 3.162 3.24 3.162 3.24m.802 2.611 1.231 1.243s.357.287.43-.711a78.82 78.82 0 0 1 .144-1.746"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgFlightTransitionAdditionalMobile);
var _default = exports["default"] = Memo;